export enum ActivityLevel { 
    HighActivity = 1,
    LowActivity = 3
    }